import MyTypography from "@saleor/components/MyTypography";
import NumberFormat from "@saleor/components/NumberFormat";
import useDebounce from "@saleor/hooks/useDebounce";
import React from "react";
import { useIntl } from "react-intl";

import useStyles from "./styles";

const CommonNumberField = ({
  name,
  value,
  handleChange,
  classes,
  allowLeadingZeros = true,
  fixedDecimalScale = true,
  placeholder = "0",
  decimalScale = 0,
  onComplete,
  error,
  id = ""
}) => {
  const onChange = e => {
    handleChange(e);
    onComplete(e.target.value);
  };
  return (
    <div className={classes.boxQuantity}>
      <NumberFormat
        customClass={classes.numberInput}
        name={name}
        onChange={onChange}
        value={value}
        rightAlignPlaceholder={true}
        allowNegative={false}
        allowLeadingZeros={allowLeadingZeros}
        fixedDecimalScale={fixedDecimalScale}
        placeholder={placeholder}
        decimalScale={decimalScale}
        error={!!error}
        id={id}
      />
    </div>
  );
};

const ItemNoFormatter = (row: NotRefOrderLine, cell) => (
  <MyTypography variant={"body3"}>{row[cell.id]}</MyTypography>
);
const materialDescriptionFormatter = (row: NotRefOrderLine, cell) => (
  <MyTypography variant={"body3"}>{row[cell.id]}</MyTypography>
);

function useFormatters(formik) {
  const intl = useIntl();
  const classes = useStyles();

  const handleChange = useDebounce(formik.handleChange, 100);

  const materialCodeFormatter = (row: NotRefOrderLine, col: TableColumn) => (
    <div>
      <div className={classes.rowFlex}>
        <MyTypography variant={"body3"}>
          {row[col.id] || <span style={{ color: "#999" }}>ค้นหาสินค้า</span>}
        </MyTypography>
      </div>
    </div>
  );

  const pricePerUnitFormatter = (row: NotRefOrderLine, col, _, mode: Imode) => {
    if (row?.materialType === "85" && row?.manualPriceFlag) {
      return (
        <CommonNumberField
          name={`lines[${row?.indexNumber}].${col.id}`}
          value={row[col.id]}
          handleChange={handleChange}
          classes={classes}
          allowLeadingZeros={false}
          fixedDecimalScale={true}
          placeholder="ระบุราคา"
          decimalScale={2}
          onComplete={() => null}
          error={mode?.error}
          id={`${col.id}Field`}
        />
      );
    } else if (row?.priceStatus === "E" && row?.priceStatusDesc) {
      return (
        <MyTypography variant="body3" color="error">
          {row.priceStatusDesc}
        </MyTypography>
      );
    } else {
      return <span>-</span>;
    }
  };

  const pricePerUnitHeaderFormatter = () => (
    <MyTypography variant={"subtitle3"} style={{ position: "relative" }}>
      {intl.formatMessage({ defaultMessage: "ราคาต่อหน่วย (THB)" })}
      <span className={classes.required}>*</span>
    </MyTypography>
  );

  return {
    ItemNoFormatter,
    materialDescriptionFormatter,
    materialCodeFormatter,
    pricePerUnitFormatter,
    pricePerUnitHeaderFormatter
  };
}

export default useFormatters;
